import config from '../../config';

/*
  RoleAdmin = 1
  RoleSubAdmin = 2
  RoleClient = 3
  RoleClientAccMgr = 4
  RoleUser = 5
*/

const menu = {
  client: { id: 1, text: 'Clients', url: '/clients' },
  users: { id: 2, text: 'Users', url: '/users' },
  Campaigns: { id: 3, text: 'Campaigns', url: '/campaign' },
  Videos: { id: 4, text: 'Videos', url: '/videos' },
  Splash: { id: 5, text: 'Splash', url: '/splash' },
  Insights: { id: 6, text: 'Insights', url: '/insights' },
  Media: { id: 7, text: 'Videos', url: '/media/legacy' }, // @TODO remove once new submissions page is consolidated
  Plugins: { id: 8, text: 'Plugins', url: '/plugins' },
  Submissions: { id: 9, text: 'Media', url: '/media' }
};

/**
 * Get menu by role and feature toggle
 */
export default (role) => {
  // role admin
  if (role === 1) {
    return [menu.client];
  }

  const vp2MenuOptions = [menu.Campaigns, menu.Media];

  if (config.pluginsV2Enabled) {
    vp2MenuOptions.push(menu.Plugins);
  }

  vp2MenuOptions.splice(1, 1, menu.Submissions);

  return vp2MenuOptions;
};

export const getSettingsDropDown = (isUserClient, isSso) => {
  return isUserClient
    ? [
        { id: 10, text: 'Billing', url: '/billing' },
        {
          id: 11,
          text: 'Users',
          url: '/organization',
          isFeature: true,
          feature: 'organization_menu_link'
        },
        !isSso ? { id: 12, text: 'Change Password', url: '/change/password' } : null,
        { id: 13, text: 'Sign Out' }
      ]
    : [
        { id: 12, text: 'Change Password', url: '/change/password' },
        { id: 13, text: 'Sign Out' }
      ];
};
export const getMenuIcons = () => {
  return [
    { id: 13, text: 'Help Center', url: config.helpCenterLink, icon: 'HelpCircle' },
    { id: 14, text: 'Settings', url: '/settings', icon: 'Settings' }
  ];
};



// WEBPACK FOOTER //
// ./src/redux/data/menu.js